import T from 'prop-types';

export const imgType = T.shape({
  src: T.string,
  alt: T.string,
});

export const backgroundImageType = T.shape({
  src: T.string,
  backgroundRepeat: T.string,
  backgroundPosition: T.string,
  backgroundSize: T.string,
  backgroundOpacity: T.string,
});



// WEBPACK FOOTER //
// ./src/types/index.js